/**
 * PATH: apps/quote/src/components/builder/panels/takeoff-assist/SimilarRowCard.tsx
 * PURPOSE: Similar row card for takeoff suggestions
 */

import { ArrowRight, Copy } from 'lucide-react'
import type { TakeoffSimilarRow } from '@/lib/quoteApi'

export default function SimilarRowCard({
  row, onJump, onCopyApplication,
}: {
  row: TakeoffSimilarRow; onJump: () => void; onCopyApplication: () => void
}) {
  return (
    <div className="p-2.5 bg-slate-50 dark:bg-slate-800 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-sm text-slate-900 dark:text-white line-clamp-1">
            {row.description || row.location || 'Untitled'}
          </p>
          {row.application_name && (
            <p className="text-xs text-slate-500 mt-0.5">App: {row.application_name}</p>
          )}
          <div className="flex items-center gap-1.5 mt-1">
            <span className="text-[10px] text-blue-600 dark:text-blue-400">
              {Math.round(row.similarity)}% similar
            </span>
          </div>
        </div>
        <div className="flex items-center gap-1 shrink-0">
          <button onClick={onJump} className="p-1.5 hover:bg-slate-200 dark:hover:bg-slate-600 rounded" title="Jump to row">
            <ArrowRight className="w-3.5 h-3.5 text-slate-500" />
          </button>
          {row.application_id && (
            <button onClick={onCopyApplication} className="p-1.5 hover:bg-slate-200 dark:hover:bg-slate-600 rounded" title="Copy application">
              <Copy className="w-3.5 h-3.5 text-slate-500" />
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
